import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Tache} from '@/models';
import {TacheService} from "@/xhttp/TacheService";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class TacheFilter {

	name: string = '';
	email: string = '';
	remarques: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';
	country: string = '';

	public clear(): void {
		this.name = '';
		this.email = '';
		this.remarques = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
		this.country = '';
	}

	public toString(): string {
		return JSON.stringify(this);
	}
}

class TacheState extends PaginatorFilterState<TacheFilter> {
	tache: Tache = null;
	taches: ResultType<Tache> = null;
	public constructor() {
		super(new TacheFilter(), 'taches', 'tache', 'id', AscDesc.DESC, 20)
	}
}

class TacheStore {

	@XHTTPService(() => Tache)
	private tacheService: TacheService;
	private  _store: Store<any>;

	public state: TacheState = new TacheState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'taches', 'tache'),
	};

	public actions = {
		...StandardAction<Tache, TacheState>(() => Tache, 'tache'),
		...PaginatorActionWithFilters<Tache, TacheState>(() => Tache, 'taches', 'tache'),
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new TacheStore();
const storeTache = new Vuex.Store(instance);
instance.init(storeTache);

const instancePrix = new TacheStore();
export const storeTachePrix = new Vuex.Store(instancePrix);
instancePrix.init(storeTachePrix);

store.registerModule('tache', storeTache);
store.registerModule('tachePrix', storeTachePrix);
export default storeTache;